import { ReloadOutlined } from '@ant-design/icons';

import { useAuth0 } from '@auth0/auth0-react';
import { Alert, Button, Space, Typography } from 'antd';

import { localStorageUtility } from '../../clientUtils';

const { Title, Paragraph } = Typography;

const AuthError = ({ error, errorDescription }) => {
  const { logout } = useAuth0();

  if (!error && !errorDescription) {
    return null;
  }

  const handleRetry = () => {
    localStorageUtility.onLogout();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  const getErrorMessage = () => {
    if (errorDescription) {
      return errorDescription;
    }

    switch (error) {
      case 'access_denied':
        return 'Access denied. Please check your login method.';
      case 'unauthorized':
        return 'You are not authorized to access this application.';
      case 'login_required':
        return 'Login is required to access this application.';
      default:
        return 'An authentication error occurred. Please try again.';
    }
  };

  const getErrorTitle = () => {
    const desc = errorDescription?.toLowerCase() || '';
    if (desc.includes('google sso')) {
      return 'Please Use Google SSO';
    }
    if (desc.includes('email and password')) {
      return 'Please Use Email/Password Login';
    }
    return 'Authentication Error';
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '20px',
        backgroundColor: '#f0f2f5'
      }}>
      <div style={{ maxWidth: '500px', width: '100%' }}>
        <Alert
          description={
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <Paragraph style={{ margin: 0, fontSize: '16px' }}>{getErrorMessage()}</Paragraph>
              <Space>
                <Button icon={<ReloadOutlined />} onClick={handleRetry} size="large" type="primary">
                  Try Again
                </Button>
              </Space>
            </Space>
          }
          message={
            <Title level={4} style={{ margin: 0 }}>
              {getErrorTitle()}
            </Title>
          }
          showIcon
          style={{ padding: '24px' }}
          type="error"
        />
      </div>
    </div>
  );
};

export default AuthError;
